(function () {
  "use strict";

  var root = document.querySelector("[data-drsknn-pricing-v2]");
  if (!root || root.dataset.pricingV2Ready === "true") return;
  root.dataset.pricingV2Ready = "true";

  var legacyHub = document.querySelector("[data-drsknn-pricing-v2-source] > .drsknn-pricing-hub");
  if (legacyHub) {
    legacyHub.setAttribute("hidden", "");
    legacyHub.setAttribute("aria-hidden", "true");
  }

  function setPricingBookingLayerActive(active) {
    var marker = "drsknn-pricing-booking-open";
    var styleId = "drsknn-pricing-booking-interaction-fix";
    var style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      style.textContent =
        "html." + marker + " #iubenda-cs-banner," +
        "html." + marker + " .iubenda-cs-overlay{" +
        "display:none!important;visibility:hidden!important;pointer-events:none!important}" +
        "html." + marker + " .drsknn-pricing-selection-tray{" +
        "display:none!important;visibility:hidden!important;pointer-events:none!important}" +
        "html." + marker + " .drsknn-pricing-modal-backdrop," +
        "html." + marker + " .drsknn-ui-modal{" +
        "display:none!important;visibility:hidden!important;pointer-events:none!important}" +
        "html." + marker + " [data-drsknn-landing-modal]{" +
        "-webkit-backdrop-filter:none!important;backdrop-filter:none!important;pointer-events:none!important}" +
        "html." + marker + " [data-drsknn-landing-modal-frame]," +
        "html." + marker + " [data-drsknn-landing-modal-close]{" +
        "pointer-events:auto!important}";
      (document.head || document.documentElement).appendChild(style);
    }
    document.documentElement.classList.toggle(marker, Boolean(active));
    if (document.body) document.body.classList.toggle(marker, Boolean(active));
  }

  var pricingBookingModal = document.querySelector("[data-drsknn-landing-modal]");
  if (pricingBookingModal && typeof MutationObserver === "function") {
    new MutationObserver(function () {
      var isPricingBooking =
        pricingBookingModal.classList.contains("is-open") &&
        pricingBookingModal.dataset.pricingV2Trigger === "true";
      setPricingBookingLayerActive(isPricingBooking);
    }).observe(pricingBookingModal, { attributes: true, attributeFilter: ["class", "data-pricing-v2-trigger"] });
  }

  window.openDrSknnContainedBooking = function (url, trigger) {
    var modal = document.querySelector("[data-drsknn-landing-modal]");
    var frame = document.querySelector("[data-drsknn-landing-modal-frame]");
    var close = document.querySelector("[data-drsknn-landing-modal-close]");
    if (!modal || !frame || !url) return false;
    try {
      var bookingUrl = new URL(url, window.location.href);
      var isDirectPricingBooking =
        /^https:\/\/(?:www\.)?drsknn\.uk$/i.test(bookingUrl.origin) &&
        bookingUrl.searchParams.get("direct") === "1" &&
        bookingUrl.searchParams.get("booking_mode") === "direct_service" &&
        bookingUrl.searchParams.get("campaign") === "pricing_board" &&
        bookingUrl.searchParams.get("funnel_stage") === "pricing_row_cta";
      if (isDirectPricingBooking) bookingUrl.searchParams.set("embedded_pricing", "1");
      url = bookingUrl.toString();
    } catch (_) {}
    try {
      if (
        window.DrSknnPricingExperience &&
        typeof window.DrSknnPricingExperience.clearSelection === "function"
      ) {
        window.DrSknnPricingExperience.clearSelection();
      } else {
        document.querySelectorAll(".drsknn-pricing-selection-tray").forEach(function (tray) {
          tray.hidden = true;
        });
      }
    } catch (_) {}
    try {
      var pricingClose = document.querySelector("[data-pricing-close-modal]");
      if (pricingClose) pricingClose.click();
    } catch (_) {}
    frame.removeAttribute("inert");
    frame.style.pointerEvents = "auto";
    frame.setAttribute("src", url);
    modal.dataset.pricingV2Trigger = trigger ? "true" : "false";
    setPricingBookingLayerActive(Boolean(trigger));
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      node.dataset.drsknnLandingModalOverflow = node.style.overflow || "";
      node.style.overflow = "hidden";
    });
    if (close && close.focus) close.focus();
    return true;
  };

  window.addEventListener("message", function (event) {
    var modal = document.querySelector("[data-drsknn-landing-modal]");
    var frame = document.querySelector("[data-drsknn-landing-modal-frame]");
    if (!modal || !frame || !event || !event.data) return;
    if (event.data.type !== "drsknn:pricing-booking-back") return;
    if (event.source !== frame.contentWindow) return;
    if (!/^https:\/\/(?:www\.)?drsknn\.uk$/i.test(event.origin || "")) return;
    var close = document.querySelector("[data-drsknn-landing-modal-close]");
    setPricingBookingLayerActive(false);
    if (close && typeof close.click === "function") close.click();
  });

  var treatments = [
    { key: "hairreduction", label: "Hair reduction", description: "Face and body hair-reduction pricing by treatment area.", areas: ["body", "hair"], terms: "laser unwanted hair face legs underarms bikini back chest men women" },
    { key: "hydrafacial", label: "HydraFacial", description: "Cleansing, hydration and targeted glow programmes.", areas: ["skin", "face"], terms: "facial glow dry dull congested pores hydration acne cleanse" },
    { key: "dsmicroneedling", label: "Personalised Dr Sknn Serum Lift", description: "Microneedling and nano-infusion serum programmes.", areas: ["skin", "face", "body", "hair"], terms: "microneedling nano infusion serum lift scars texture pores collagen scalp" },
    { key: "co2", label: "CO2 laser", description: "Fractional resurfacing prices for face and body areas.", areas: ["skin", "face", "body"], terms: "fractional resurfacing scars stretch marks lines wrinkles texture pores laser" },
    { key: "origin", label: "Origin Glass Laser", description: "Laser pricing for eyes, face, neck, body, scars and scalp.", areas: ["skin", "face", "body", "hair"], terms: "glass laser origin eyes neck scars stretch marks scalp acne rejuvenation" },
    { key: "onda", label: "ONDA body sculpt", description: "Body-contouring prices by number of treatment areas.", areas: ["body"], terms: "fat cellulite body contouring sculpt coolwaves laxity tightening" },
    { key: "exosomes", label: "Exosomes", description: "Regenerative support programmes for skin and hair routes.", areas: ["skin", "face", "hair"], terms: "regenerative repair collagen skin hair scalp healing ageing" },
    { key: "dermalux", label: "Dermalux LED", description: "LED treatment and programme pricing.", areas: ["skin", "face", "body", "hair"], terms: "led red blue nir acne redness healing inflammation sensitive scalp glow" },
    { key: "mh10", label: "M-HA 10", description: "Hydration-focused injectable skin-quality pricing.", areas: ["skin", "face"], terms: "mha m-ha 10 skin booster hydration fine lines injectable" },
    { key: "polynucleotide", label: "Polynucleotides", description: "Skin and under-eye biostimulation programmes.", areas: ["skin", "face"], terms: "pn under eye eyes biostimulation regeneration ageing neck skin quality" },
    { key: "hifu", label: "HIFU", description: "Face, neck and body tightening price options.", areas: ["face", "body"], terms: "ultrasound lift lifting tightening laxity jawline neck body" },
    { key: "biologicalfiller", label: "Biological filler", description: "Regenerative volumisation programme pricing.", areas: ["face"], terms: "bio filler regenerative volume structure face collagen" },
    { key: "nctf135", label: "NCTF 135 HA", description: "Mesotherapy pricing for skin quality and radiance.", areas: ["skin", "face"], terms: "nctf mesotherapy skin booster glow hydration radiance ageing" },
    { key: "ipl", label: "IPL / Illumifacial", description: "Pigment, redness and light-based facial pricing.", areas: ["skin", "face", "body"], terms: "illumifacial light pigment pigmentation redness rosacea vessels sun damage acne hair" },
    { key: "prp", label: "PRP", description: "Platelet-rich plasma pricing for skin, body and hair.", areas: ["skin", "face", "body", "hair"], terms: "platelet rich plasma hair growth scalp skin rejuvenation scars stretch marks" },
    { key: "antiwrinkle", label: "Anti-wrinkle injections", description: "Doctor and nurse line-softening programme pricing.", areas: ["face"], terms: "botox lines wrinkles forehead frown crows feet jawline sweating hyperhidrosis" },
    { key: "dermalfillers", label: "Dermal fillers", description: "Lips, cheeks, chin, jawline and facial-balancing prices.", areas: ["face"], terms: "filler lip lips cheeks chin jawline tear trough profile balance volume" },
    { key: "chemicalpeel", label: "Chemical peels", description: "Peel pricing for acne, pigment, texture and glow.", areas: ["skin", "face", "body"], terms: "peel acne pigmentation melasma texture glow pores resurfacing" },
    { key: "threadingwaxingtinting", label: "Threading, waxing & tinting", description: "Quick-service prices for brows and facial finishing.", areas: ["face", "body", "hair"], terms: "eyebrow brows threading waxing tinting upper lip chin grooming" },
    { key: "spmu", label: "SPMU & Lip Blush", description: "Microblading, lip blush and lash-line treatment prices.", areas: ["face", "hair"], terms: "semi permanent makeup spmu microblading eyebrows lip blush eyeliner lash line" }
  ];

  var treatmentByKey = treatments.reduce(function (index, item) {
    index[item.key] = item;
    return index;
  }, {});

  var serviceLabelOverrides = {
    "3575459": "Abdomen laser hair reduction",
    "3575470": "Full arms laser hair reduction",
    "3574770": "Full face (PRP)",
    "3574771": "Full face, brow and under-eye (PRP)",
    "3574772": "Full face, brow, under-eye and neck (PRP)",
    "3574773": "Full face (PRP with hyaluronic acid)",
    "3574778": "Brow and under-eye (PRP)",
    "3574780": "Body (PRP with hyaluronic acid) — per vial"
  };

  var areas = [
    { key: "skin", label: "Skin", description: "Acne, pigment, redness, texture or glow" },
    { key: "face", label: "Face", description: "Lines, eyes, volume, lips or profile" },
    { key: "body", label: "Body", description: "Hair, contour, laxity, acne or scarring" },
    { key: "hair", label: "Hair & scalp", description: "Thinning, shedding, scalp or brows" },
    { key: "not-sure", label: "Not sure", description: "Let the clinician guide the starting point" }
  ];

  var concerns = {
    skin: [
      { key: "glow-hydration", label: "Glow, hydration or healthier-looking skin", description: "Dullness, dryness, barrier support and skin quality.", matches: ["hydrafacial", "dermalux", "nctf135", "mh10", "chemicalpeel"] },
      { key: "ageing-collagen", label: "Ageing, hormonal or changing skin", description: "Collagen, elasticity, lines and changing skin quality.", matches: ["polynucleotide", "exosomes", "nctf135", "mh10", "prp", "co2", "origin"] },
      { key: "acne-breakouts", label: "Acne, breakouts or acne marks", description: "Active breakouts, recurring acne and post-acne marks.", matches: ["hydrafacial", "chemicalpeel", "dermalux", "ipl", "dsmicroneedling"] },
      { key: "acne-scars-texture", label: "Acne scarring or uneven texture", description: "Indented scars, roughness, pores and texture change.", matches: ["co2", "origin", "dsmicroneedling", "prp", "chemicalpeel"] },
      { key: "pigmentation-redness", label: "Pigmentation, redness or sun damage", description: "Brown marks, melasma, rosacea, vessels and uneven tone.", matches: ["ipl", "chemicalpeel", "origin", "hydrafacial"] },
      { key: "sensitive-reactive", label: "Sensitive, inflamed or reactive skin", description: "Sensitivity, redness, inflammation and barrier concerns.", matches: ["dermalux", "hydrafacial"] },
      { key: "pores-congestion", label: "Pores, milia or congested skin", description: "Open pores, oiliness, whiteheads and small bumps.", matches: ["hydrafacial", "chemicalpeel", "dsmicroneedling", "co2"] },
      { key: "scars-keloids", label: "Scars, keloids or uneven skin", description: "Non-acne scars, raised scars, texture and colour change.", matches: ["co2", "origin", "prp"] }
    ],
    face: [
      { key: "lines-wrinkles", label: "Lines, wrinkles or collagen change", description: "Movement lines, texture, collagen and skin quality.", matches: ["antiwrinkle", "co2", "origin", "polynucleotide"] },
      { key: "eyes", label: "Tired eyes or under-eyes", description: "Hollows, creasing, dullness and under-eye skin quality.", matches: ["polynucleotide", "nctf135", "dermalfillers", "prp"] },
      { key: "volume-shape", label: "Volume loss or facial shape", description: "Cheeks, structure, proportion and facial balance.", matches: ["dermalfillers", "biologicalfiller", "exosomes"] },
      { key: "jawline-profile", label: "Jawline, chin or profile", description: "Definition, profile balance, lower-face shape and jawline.", matches: ["dermalfillers", "antiwrinkle", "hifu"] },
      { key: "lips", label: "Lips or lip definition", description: "Hydration, volume, shape, outline or longer-lasting colour.", matches: ["dermalfillers", "spmu"] },
      { key: "neck-laxity", label: "Neck or skin laxity", description: "Firmness, creasing, lower-face and neck changes.", matches: ["hifu", "polynucleotide", "co2", "antiwrinkle"] },
      { key: "natural-refresh", label: "A natural-looking refresh", description: "Skin quality, hydration and subtle regenerative routes.", matches: ["hydrafacial", "polynucleotide", "nctf135"] }
    ],
    body: [
      { key: "unwanted-hair", label: "Unwanted face or body hair", description: "Hair-reduction pricing across female and male treatment areas.", matches: ["hairreduction"] },
      { key: "fat-cellulite", label: "Stubborn fat or cellulite", description: "Body contour, cellulite and targeted sculpting concerns.", matches: ["onda"] },
      { key: "laxity-tightening", label: "Loose skin or body tightening", description: "Firmness and laxity across suitable body areas.", matches: ["hifu", "onda", "co2", "origin"] },
      { key: "body-acne", label: "Body acne or breakouts", description: "Breakouts, inflammation and post-acne change on the body.", matches: ["ipl", "chemicalpeel", "dermalux"] },
      { key: "scars-stretchmarks", label: "Scars or stretch marks", description: "Texture, colour change and regenerative scar routes.", matches: ["co2", "origin", "prp", "dsmicroneedling"] },
      { key: "body-pigment", label: "Pigmentation or redness", description: "Uneven tone, pigment and redness on suitable body areas.", matches: ["ipl", "chemicalpeel"] },
      { key: "grooming", label: "Waxing, threading or tinting", description: "Brow, facial-hair and finishing services.", matches: ["threadingwaxingtinting"] }
    ],
    hair: [
      { key: "thinning-shedding", label: "Hair thinning or shedding", description: "Density, shedding and regenerative scalp routes.", matches: ["prp", "exosomes", "dsmicroneedling", "dermalux"] },
      { key: "scalp-health", label: "Scalp health or irritation", description: "Dryness, inflammation and scalp-support routes.", matches: ["prp", "dermalux", "origin"] },
      { key: "hair-unwanted", label: "Unwanted hair", description: "Face and body hair-reduction pricing by area.", matches: ["hairreduction"] },
      { key: "brows-definition", label: "Brows or longer-lasting definition", description: "Microblading, threading, waxing and tinting.", matches: ["spmu", "threadingwaxingtinting"] }
    ],
    "not-sure": [
      { key: "guidance", label: "I would like clinical guidance", description: "Start with a free consultation instead of guessing a treatment.", matches: [] }
    ]
  };

  var state = { mode: "help", area: "", concern: "" };
  var areaGrid = root.querySelector("[data-pv2-area-grid]");
  var concernWrap = root.querySelector("[data-pv2-concerns]");
  var concernGrid = root.querySelector("[data-pv2-concern-grid]");
  var concernTitle = root.querySelector("[data-pv2-concern-title]");
  var results = root.querySelector("[data-pv2-results]");
  var resultsGrid = root.querySelector("[data-pv2-results-grid]");
  var resultsTitle = root.querySelector("[data-pv2-results-title]");
  var searchInput = root.querySelector("[data-pv2-search]");
  var searchGrid = root.querySelector("[data-pv2-search-grid]");
  var searchMeta = root.querySelector("[data-pv2-search-meta]");
  var modeButtons = Array.prototype.slice.call(root.querySelectorAll("[data-pv2-mode]"));
  var stages = Array.prototype.slice.call(root.querySelectorAll("[data-pv2-stage]"));

  function makeButton(className, label, description, attributes) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = className;
    Object.keys(attributes || {}).forEach(function (name) {
      button.setAttribute(name, attributes[name]);
    });
    var strong = document.createElement("strong");
    strong.textContent = label;
    var span = document.createElement("span");
    span.textContent = description;
    button.appendChild(strong);
    button.appendChild(span);
    return button;
  }

  function setQuery(values) {
    try {
      var url = new URL(window.location.href);
      Object.keys(values).forEach(function (key) {
        if (values[key]) url.searchParams.set(key, values[key]);
        else url.searchParams.delete(key);
      });
      window.history.replaceState({}, "", url.toString());
    } catch (_) {}
  }

  function treatmentCard(item, matchLabel) {
    var card = document.createElement("article");
    card.className = "drsknn-pricing-v2__treatment";
    card.setAttribute("data-pv2-treatment", item.key);

    var kicker = document.createElement("span");
    kicker.className = matchLabel ? "drsknn-pricing-v2__match" : "drsknn-pricing-v2__card-kicker";
    kicker.textContent = matchLabel || "Detailed price list";

    var title = document.createElement("h4");
    title.textContent = item.label;
    var copy = document.createElement("p");
    copy.textContent = item.description;
    var button = document.createElement("button");
    button.type = "button";
    button.className = "drsknn-pricing-v2__open";
    button.textContent = "See exact prices";
    button.setAttribute("data-pv2-open", item.key);
    button.setAttribute("aria-label", "See exact " + item.label + " prices");

    card.appendChild(kicker);
    card.appendChild(title);
    card.appendChild(copy);
    card.appendChild(button);
    return card;
  }

  function consultationCard() {
    var card = document.createElement("article");
    card.className = "drsknn-pricing-v2__treatment";
    var kicker = document.createElement("span");
    kicker.className = "drsknn-pricing-v2__match";
    kicker.textContent = "Safest starting point";
    var title = document.createElement("h4");
    title.textContent = "Free consultation";
    var copy = document.createElement("p");
    copy.textContent = "Let the clinician assess your concern and explain the relevant price lists. Consultations are free. A £50 reservation fee secures an appointment with a doctor, nurse or qualified practitioner.";
    var link = document.createElement("a");
    link.className = "drsknn-pricing-v2__open";
    link.href = "https://www.drsknn.uk/kiosk?tab=consultations&landing_source=drsknn_com_pricing_v2&campaign=pricing_v2&landing_page=dr_sknn_pricing_v2&funnel_stage=pricing_v2_guidance";
    link.textContent = "Choose consultation";
    link.setAttribute("data-drsknn-booking-link", "");
    card.appendChild(kicker);
    card.appendChild(title);
    card.appendChild(copy);
    card.appendChild(link);
    return card;
  }

  function renderAreas() {
    areaGrid.textContent = "";
    areas.forEach(function (area) {
      var button = makeButton("drsknn-pricing-v2__choice", area.label, area.description, {
        "data-pv2-area": area.key,
        "aria-pressed": String(state.area === area.key)
      });
      areaGrid.appendChild(button);
    });
  }

  function renderConcerns() {
    var list = concerns[state.area] || [];
    var area = areas.filter(function (item) { return item.key === state.area; })[0];
    concernTitle.textContent = state.area === "not-sure" ? "We can guide the starting point" : "What would you like help with for " + (area ? area.label.toLowerCase() : "this area") + "?";
    concernGrid.textContent = "";
    list.forEach(function (concern) {
      var button = makeButton("drsknn-pricing-v2__concern", concern.label, concern.description, {
        "data-pv2-concern": concern.key,
        "aria-pressed": String(state.concern === concern.key)
      });
      concernGrid.appendChild(button);
    });
    concernWrap.hidden = !list.length;
  }

  function selectedConcern() {
    return (concerns[state.area] || []).filter(function (item) { return item.key === state.concern; })[0] || null;
  }

  function renderResults() {
    var concern = selectedConcern();
    resultsGrid.textContent = "";
    if (!concern) {
      results.hidden = true;
      return;
    }

    if (!concern.matches.length) {
      resultsTitle.textContent = "Your clearest next step";
      resultsGrid.appendChild(consultationCard());
    } else {
      resultsTitle.textContent = "Price lists matched to “" + concern.label + "”";
      concern.matches.forEach(function (key) {
        if (treatmentByKey[key]) resultsGrid.appendChild(treatmentCard(treatmentByKey[key], "Matched to your concern"));
      });
    }
    results.hidden = false;
  }

  function normalize(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function searchScore(item, query) {
    if (!query) return 1;
    var terms = normalize(item.label + " " + item.description + " " + item.terms + " " + item.areas.join(" "));
    var words = normalize(query).split(/\s+/).filter(Boolean);
    var score = 0;
    words.forEach(function (word) {
      if (normalize(item.label).indexOf(word) !== -1) score += 8;
      else if (terms.indexOf(word) !== -1) score += 3;
    });
    return words.length && score >= words.length * 3 ? score : 0;
  }

  function renderSearch(query) {
    var ranked = treatments.map(function (item, index) {
      return { item: item, index: index, score: searchScore(item, query) };
    }).filter(function (entry) {
      return entry.score > 0;
    }).sort(function (a, b) {
      return b.score - a.score || a.index - b.index;
    });

    searchGrid.textContent = "";
    ranked.forEach(function (entry) { searchGrid.appendChild(treatmentCard(entry.item, "")); });
    if (!ranked.length) {
      var empty = document.createElement("div");
      empty.className = "drsknn-pricing-v2__empty";
      empty.textContent = "No exact match yet. Try the concern finder or choose a free consultation.";
      searchGrid.appendChild(empty);
    }
    searchMeta.textContent = ranked.length + (ranked.length === 1 ? " treatment price list" : " treatment price lists") + (query ? " matched" : "");
  }

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function normalizePriceLabel(value) {
    var label = cleanText(value).replace(/[:：]+$/, "");
    var normalized = normalize(label);
    if (!normalized || normalized === "price" || normalized === "investment") return "Price";
    if (normalized === "pay as you go" || normalized === "single per 1ml" || normalized === "single treatment") return "Single";
    if (normalized === "single") return "Single";
    if (normalized === "subscription") return "Subscription";
    if (normalized === "time" || normalized === "treatment time") return "Duration";
    if (normalized.indexOf("course") !== -1) return label.replace(/\bof\b/i, "of");
    return label.replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function roleLabel(role) {
    var normalized = String(role || "").toLowerCase();
    if (normalized === "doctor") return "Doctor";
    if (normalized === "nurse") return "Nurse";
    if (normalized === "qualified_practitioner") return "Qualified practitioner";
    if (normalized === "nurse_qualified_practitioner") return "Nurse or qualified practitioner";
    if (normalized === "any_practitioner") return "Any suitable clinician";
    return "Dr Sknn clinician";
  }

  function inferredRole(row, key) {
    var node = row;
    var context = "";
    while (node) {
      context += " " + String(node.id || "") + " " + String(node.className || "");
      if (node.matches && node.matches("[data-price-panel]")) break;
      node = node.parentElement;
    }
    context = context.toLowerCase();
    if (context.indexOf("nurse") !== -1) return "nurse";
    if (context.indexOf("doctor") !== -1) return "doctor";
    if (context.indexOf("practitioner") !== -1) return "qualified_practitioner";
    if (key === "dermalux") return "qualified_practitioner";
    if (key === "ipl") return "nurse_qualified_practitioner";
    return "any_practitioner";
  }

  function tableHeaders(table) {
    var headerRow = table.querySelector("thead tr:last-child");
    return headerRow ? Array.prototype.map.call(headerRow.children, function (cell) { return cleanText(cell.textContent); }) : [];
  }

  function roleHeaderMatches(label, role) {
    var normalized = normalize(label);
    if (role === "doctor") return normalized.indexOf("doctor") !== -1;
    if (role === "nurse") return normalized === "nurse" || normalized.indexOf("nurse price") !== -1;
    if (role === "qualified_practitioner") return normalized.indexOf("qualified practitioner") !== -1 || normalized === "practitioner";
    if (role === "nurse_qualified_practitioner") return normalized.indexOf("nurse") !== -1 || normalized.indexOf("practitioner") !== -1;
    return false;
  }

  function rowPriceEntries(row, headers, role) {
    var cells = Array.prototype.slice.call(row.children);
    var roleColumns = headers.map(function (header, index) {
      return roleHeaderMatches(header, role) ? index : -1;
    }).filter(function (index) { return index > 0; });
    var providerMatrix = headers.some(function (header) { return roleHeaderMatches(header, "doctor") || roleHeaderMatches(header, "nurse") || roleHeaderMatches(header, "qualified_practitioner"); });
    var entries = [];

    cells.slice(1).forEach(function (cell, offset) {
      var index = offset + 1;
      var value = cleanText(cell.textContent);
      var header = headers[index] || cell.getAttribute("data-mobile-label") || "Price";
      var normalizedHeader = normalize(header);
      if (!value || normalizedHeader === "choose" || normalizedHeader === "book" || cell.querySelector("[data-drsknn-pricing-service-id]")) return;
      if (providerMatrix && roleColumns.length && roleColumns.indexOf(index) === -1) return;
      if (!/£\s?[\d,]+(?:\.\d{1,2})?/.test(value) && normalizedHeader.indexOf("time") === -1 && normalizedHeader.indexOf("duration") === -1) return;
      entries.push({
        label: providerMatrix && roleColumns.length ? "Price" : normalizePriceLabel(header),
        value: value
      });
    });

    return entries.filter(function (entry, index) {
      return entries.findIndex(function (candidate) { return candidate.label === entry.label && candidate.value === entry.value; }) === index;
    });
  }

  function optionSignature(option) {
    return [normalize(option.title), option.role, option.prices.map(function (entry) { return normalize(entry.label + " " + entry.value); }).join("|")].join("::");
  }

  function collectCatalogueOptions(panel, key) {
    var directByService = new Map();
    var fallbackBySignature = new Map();
    var directSignatures = new Set();

    panel.querySelectorAll("table").forEach(function (table) {
      var headers = tableHeaders(table);
      table.querySelectorAll("tbody tr").forEach(function (row) {
        var firstCell = row.querySelector(":scope > th, :scope > td");
        var rowHeading = cleanText(firstCell ? firstCell.textContent : "");
        if (!rowHeading) return;
        var links = Array.prototype.slice.call(row.querySelectorAll("[data-drsknn-pricing-service-id]"));

        if (links.length) {
          links.forEach(function (link) {
            var serviceId = link.getAttribute("data-drsknn-pricing-service-id");
            if (!serviceId || directByService.has(serviceId)) return;
            var role = link.getAttribute("data-drsknn-pricing-role") || "any_practitioner";
            var option = {
              direct: true,
              link: link,
              prices: rowPriceEntries(row, headers, role),
              role: role,
              serviceId: serviceId,
              title: serviceLabelOverrides[serviceId] || rowHeading
            };
            directByService.set(serviceId, option);
            directSignatures.add(optionSignature(option));
          });
          return;
        }

        var fallbackRole = inferredRole(row, key);
        var fallbackPrices = rowPriceEntries(row, headers, fallbackRole);
        if (!fallbackPrices.length) return;
        var fallback = {
          direct: false,
          link: null,
          prices: fallbackPrices,
          role: fallbackRole,
          serviceId: "",
          title: rowHeading
        };
        var signature = optionSignature(fallback);
        if (!fallbackBySignature.has(signature)) fallbackBySignature.set(signature, fallback);
      });
    });

    var options = Array.from(directByService.values());
    fallbackBySignature.forEach(function (option, signature) {
      if (!directSignatures.has(signature)) options.push(option);
    });
    return options;
  }

  function genericBookingUrl(panel) {
    var link = Array.prototype.find.call(panel.querySelectorAll("[data-drsknn-booking-link]"), function (candidate) {
      return !candidate.hasAttribute("data-drsknn-pricing-service-id") && candidate.getAttribute("href");
    });
    return link ? link.getAttribute("href") : "https://www.drsknn.uk/kiosk?tab=consultations&landing_source=drsknn_com_pricing_v2&campaign=pricing_v2";
  }

  function copyServiceLink(source, title) {
    var link = document.createElement("a");
    Array.prototype.forEach.call(source.attributes, function (attribute) {
      if (attribute.name === "href" || attribute.name.indexOf("data-drsknn-") === 0) link.setAttribute(attribute.name, attribute.value);
    });
    link.className = "drsknn-pv2-catalogue__select";
    link.textContent = "Choose this treatment";
    link.setAttribute("role", "button");
    link.setAttribute("aria-pressed", "false");
    link.setAttribute("aria-label", "Choose treatment: " + title);
    link.setAttribute("data-pv2-option-link", "");
    return link;
  }

  function optionCard(option, fallbackUrl) {
    var article = document.createElement("article");
    var heading = document.createElement("h3");
    var provider = document.createElement("span");
    var prices = document.createElement("div");
    var action;
    article.className = "drsknn-pv2-catalogue__option";
    article.setAttribute("data-pv2-option", "");
    article.setAttribute("data-pv2-option-title", option.title);
    article.setAttribute("data-pv2-option-provider", option.role);
    article.setAttribute("data-pv2-option-price", option.prices.map(function (entry) { return entry.label + " " + entry.value; }).join(" · "));
    article.setAttribute("data-pv2-option-search", normalize(option.title + " " + roleLabel(option.role) + " " + option.prices.map(function (entry) { return entry.label + " " + entry.value; }).join(" ")));

    provider.className = "drsknn-pv2-catalogue__provider";
    provider.textContent = roleLabel(option.role);
    heading.textContent = option.title;
    prices.className = "drsknn-pv2-catalogue__prices";
    option.prices.forEach(function (entry) {
      var price = document.createElement("div");
      var label = document.createElement("span");
      var value = document.createElement("strong");
      label.textContent = entry.label;
      value.textContent = entry.value;
      price.appendChild(label);
      price.appendChild(value);
      prices.appendChild(price);
    });

    if (option.direct) {
      action = copyServiceLink(option.link, option.title);
    } else {
      action = document.createElement("a");
      action.className = "drsknn-pv2-catalogue__select drsknn-pv2-catalogue__select--secondary";
      action.href = fallbackUrl;
      action.textContent = "Ask about this treatment";
      action.setAttribute("data-drsknn-booking-link", "");
      action.setAttribute("data-drsknn-booking-key", "pricing-v2-unmapped-price");
    }

    article.appendChild(provider);
    article.appendChild(heading);
    article.appendChild(prices);
    article.appendChild(action);
    return article;
  }

  function catalogueFilters(roles) {
    var labels = [{ value: "all", label: "All clinicians" }];
    roles.forEach(function (role) { labels.push({ value: role, label: roleLabel(role) }); });
    var wrap = document.createElement("div");
    wrap.className = "drsknn-pv2-catalogue__filters";
    wrap.setAttribute("role", "group");
    wrap.setAttribute("aria-label", "Filter prices by clinician");
    labels.forEach(function (item, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.textContent = item.label;
      button.setAttribute("data-pv2-provider-filter", item.value);
      button.setAttribute("aria-pressed", String(index === 0));
      wrap.appendChild(button);
    });
    return wrap;
  }

  function enableCatalogueControls(catalogue) {
    var input = catalogue.querySelector("[data-pv2-catalogue-search]");
    var filterButtons = Array.prototype.slice.call(catalogue.querySelectorAll("[data-pv2-provider-filter]"));
    var cards = Array.prototype.slice.call(catalogue.querySelectorAll("[data-pv2-option]"));
    var meta = catalogue.querySelector("[data-pv2-catalogue-meta]");
    var showAll = catalogue.querySelector("[data-pv2-show-all]");
    var activeRole = "all";
    var expanded = false;

    function update() {
      var query = normalize(input.value);
      var matches = cards.filter(function (card) {
        var roleMatch = activeRole === "all" || card.getAttribute("data-pv2-option-provider") === activeRole;
        var searchMatch = !query || String(card.getAttribute("data-pv2-option-search") || "").indexOf(query) !== -1;
        return roleMatch && searchMatch;
      });
      var limit = !query && activeRole === "all" && !expanded ? 12 : matches.length;
      cards.forEach(function (card) { card.hidden = true; });
      matches.slice(0, limit).forEach(function (card) { card.hidden = false; });
      var visible = Math.min(matches.length, limit);
      meta.textContent = matches.length ? "Showing " + visible + " of " + matches.length + (matches.length === 1 ? " treatment option" : " treatment options") : "No matching treatment options";
      showAll.hidden = expanded || query || activeRole !== "all" || matches.length <= 12;
      showAll.textContent = "Show all " + matches.length + " treatment options";
    }

    input.addEventListener("input", update);
    filterButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        activeRole = button.getAttribute("data-pv2-provider-filter") || "all";
        filterButtons.forEach(function (candidate) { candidate.setAttribute("aria-pressed", String(candidate === button)); });
        update();
      });
    });
    showAll.addEventListener("click", function () { expanded = true; update(); });
    update();
  }

  function ensureStandardCatalogue(key) {
    var panel = document.querySelector('[data-price-panel="' + key + '"]');
    if (!panel || panel.getAttribute("data-pv2-standardized") === "true") return panel;
    var item = treatmentByKey[key];
    var options = collectCatalogueOptions(panel, key);
    var fallbackUrl = genericBookingUrl(panel);
    var legacy = document.createElement("div");
    var catalogue = document.createElement("section");
    var head = document.createElement("header");
    var eyebrow = document.createElement("span");
    var title = document.createElement("h2");
    var copy = document.createElement("p");
    var controls = document.createElement("div");
    var searchWrap = document.createElement("label");
    var searchLabel = document.createElement("span");
    var search = document.createElement("input");
    var meta = document.createElement("p");
    var grid = document.createElement("div");
    var showAll = document.createElement("button");
    var guidance = document.createElement("aside");
    var guidanceCopy = document.createElement("div");
    var guidanceTitle = document.createElement("strong");
    var guidanceText = document.createElement("p");
    var guidanceLink = document.createElement("a");
    var roles = options.map(function (option) { return option.role; }).filter(function (role, index, list) { return list.indexOf(role) === index; });

    legacy.className = "drsknn-pv2-legacy-data";
    legacy.hidden = true;
    legacy.setAttribute("aria-hidden", "true");
    while (panel.firstChild) legacy.appendChild(panel.firstChild);
    panel.appendChild(legacy);

    catalogue.className = "drsknn-pv2-catalogue";
    catalogue.setAttribute("data-pv2-catalogue", key);
    eyebrow.className = "drsknn-pv2-catalogue__eyebrow";
    eyebrow.textContent = "Current published pricing";
    title.textContent = "Choose a treatment to explore";
    copy.textContent = (item ? item.description + " " : "") + "Review the published prices for each individual option, then choose a treatment below. Your clinician confirms suitability and the total cost of any agreed plan before treatment.";
    head.className = "drsknn-pv2-catalogue__head";
    head.appendChild(eyebrow);
    head.appendChild(title);
    head.appendChild(copy);

    controls.className = "drsknn-pv2-catalogue__controls";
    searchWrap.className = "drsknn-pv2-catalogue__search";
    searchLabel.textContent = "Search treatment options";
    search.type = "search";
    search.autocomplete = "off";
    search.placeholder = "Search an area or option…";
    search.setAttribute("data-pv2-catalogue-search", "");
    searchWrap.appendChild(searchLabel);
    searchWrap.appendChild(search);
    controls.appendChild(searchWrap);
    if (roles.length > 1) controls.appendChild(catalogueFilters(roles));

    meta.className = "drsknn-pv2-catalogue__meta";
    meta.setAttribute("data-pv2-catalogue-meta", "");
    grid.className = "drsknn-pv2-catalogue__grid";
    options.forEach(function (option) { grid.appendChild(optionCard(option, fallbackUrl)); });
    showAll.type = "button";
    showAll.className = "drsknn-pv2-catalogue__show-all";
    showAll.setAttribute("data-pv2-show-all", "");

    guidance.className = "drsknn-pv2-catalogue__guidance";
    guidanceTitle.textContent = "Not sure which exact option is right?";
    guidanceText.textContent = "Consultations are free. A £50 reservation fee secures an appointment with a doctor, nurse or qualified practitioner. Suitability and your final price are confirmed before treatment.";
    guidanceCopy.appendChild(guidanceTitle);
    guidanceCopy.appendChild(guidanceText);
    guidanceLink.href = fallbackUrl;
    guidanceLink.textContent = "Choose consultation";
    guidanceLink.setAttribute("data-drsknn-booking-link", "");
    guidanceLink.setAttribute("data-drsknn-booking-key", key);
    guidance.appendChild(guidanceCopy);
    guidance.appendChild(guidanceLink);

    catalogue.appendChild(head);
    catalogue.appendChild(controls);
    catalogue.appendChild(meta);
    catalogue.appendChild(grid);
    catalogue.appendChild(showAll);
    catalogue.appendChild(guidance);
    panel.appendChild(catalogue);
    panel.setAttribute("data-pv2-standardized", "true");
    enableCatalogueControls(catalogue);
    return panel;
  }

  function enhanceSelectedTreatment(link) {
    var option = link ? link.closest("[data-pv2-option]") : null;
    if (!option) return;
    var uiModal = link.closest(".drsknn-ui-modal");
    var host = uiModal ? uiModal.querySelector(".drsknn-ui-modal-dialog") || uiModal : link.closest(".drsknn-pricing-modal") || link.closest(".drsknn-pricing-panel");
    var tray = host ? host.querySelector(":scope > .drsknn-pricing-selection-tray:not([hidden])") : null;
    if (!tray) return;

    var title = String(option.getAttribute("data-pv2-option-title") || "Selected treatment").trim();
    var provider = roleLabel(option.getAttribute("data-pv2-option-provider") || "");
    var published = String(option.getAttribute("data-pv2-option-price") || "").trim();
    var summary = tray.querySelector(".drsknn-pv2-selection-summary");
    var titleNode = tray.querySelector(".drsknn-pricing-selection-title");
    var metaNode = tray.querySelector(".drsknn-pricing-selection-meta");

    if (!summary) {
      summary = document.createElement("div");
      summary.className = "drsknn-pv2-selection-summary";
      summary.innerHTML =
        '<p class="drsknn-pv2-selection-label">Treatment selected</p>' +
        '<p class="drsknn-pv2-selection-published"></p>' +
        '<p class="drsknn-pv2-selection-payment">Payment today: shown before confirmation in secure booking.</p>' +
        '<p class="drsknn-pv2-selection-note">Additional treatments are never added automatically. Anything additional is discussed and priced separately first.</p>';
      if (titleNode) summary.insertBefore(titleNode, summary.querySelector(".drsknn-pv2-selection-published"));
      if (metaNode) summary.insertBefore(metaNode, summary.querySelector(".drsknn-pv2-selection-published"));
      tray.insertBefore(summary, tray.firstChild);
    }

    tray.classList.add("drsknn-pricing-selection-tray--v2");
    titleNode = summary.querySelector(".drsknn-pricing-selection-title");
    metaNode = summary.querySelector(".drsknn-pricing-selection-meta");
    if (titleNode) titleNode.textContent = title;
    if (metaNode) metaNode.textContent = "Clinician route: " + provider;
    summary.querySelector(".drsknn-pv2-selection-published").textContent = published ? "Published options: " + published : "Published price: confirmed for this treatment option.";
    tray.setAttribute("aria-label", "Treatment selected: " + title);
  }

  function installSelectedTreatmentEnhancement() {
    var experience = window.DrSknnPricingExperience;
    if (!experience || typeof experience.selectService !== "function" || experience.pricingV2SelectionEnhanced) return;
    var selectService = experience.selectService;
    experience.selectService = function (link) {
      var selected = selectService.call(experience, link);
      if (selected && link && link.hasAttribute("data-pv2-option-link")) enhanceSelectedTreatment(link);
      return selected;
    };
    experience.pricingV2SelectionEnhanced = true;
  }

  function setMode(mode, options) {
    state.mode = mode === "search" ? "search" : "help";
    modeButtons.forEach(function (button) {
      var selected = button.getAttribute("data-pv2-mode") === state.mode;
      button.setAttribute("aria-selected", String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    stages.forEach(function (stage) {
      stage.hidden = stage.getAttribute("data-pv2-stage") !== state.mode;
    });
    setQuery({ price_route: state.mode === "search" ? "search" : "" });
    if (state.mode === "search") {
      renderSearch(searchInput.value);
      if (!options || options.focus !== false) window.setTimeout(function () { searchInput.focus(); }, 0);
    }
  }

  function chooseArea(key) {
    state.area = concerns[key] ? key : "";
    state.concern = "";
    renderAreas();
    renderConcerns();
    renderResults();
    setQuery({ area: state.area, concern: "" });
    if (concernWrap && !concernWrap.hidden && window.matchMedia("(max-width: 620px)").matches) {
      concernWrap.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function chooseConcern(key) {
    var valid = (concerns[state.area] || []).some(function (item) { return item.key === key; });
    state.concern = valid ? key : "";
    renderConcerns();
    renderResults();
    setQuery({ area: state.area, concern: state.concern });
    if (results && !results.hidden && window.matchMedia("(max-width: 620px)").matches) {
      results.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function openPrice(key, trigger) {
    if (!treatmentByKey[key]) return;
    ensureStandardCatalogue(key);
    setQuery({ pricing: key });
    var original = trigger ? trigger.textContent : "";
    if (trigger) {
      trigger.disabled = true;
      trigger.textContent = "Opening prices…";
    }

    var attempts = 0;
    function attempt() {
      attempts += 1;
      if (typeof window.openDrSknnPricingModal === "function") {
        window.openDrSknnPricingModal(key, trigger || document.activeElement);
        if (trigger) {
          trigger.disabled = false;
          trigger.textContent = original || "See exact prices";
        }
        return;
      }
      if (attempts < 30) {
        window.setTimeout(attempt, 100);
        return;
      }
      if (trigger) {
        trigger.disabled = false;
        trigger.textContent = "Please try again";
      }
    }
    attempt();
  }

  root.addEventListener("click", function (event) {
    var areaButton = event.target.closest("[data-pv2-area]");
    if (areaButton) {
      chooseArea(areaButton.getAttribute("data-pv2-area"));
      return;
    }
    var concernButton = event.target.closest("[data-pv2-concern]");
    if (concernButton) {
      chooseConcern(concernButton.getAttribute("data-pv2-concern"));
      return;
    }
    var openButton = event.target.closest("[data-pv2-open]");
    if (openButton) openPrice(openButton.getAttribute("data-pv2-open"), openButton);
  });

  modeButtons.forEach(function (button, index) {
    button.addEventListener("click", function () { setMode(button.getAttribute("data-pv2-mode")); });
    button.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      var next = event.key === "ArrowRight" ? (index + 1) % modeButtons.length : (index - 1 + modeButtons.length) % modeButtons.length;
      modeButtons[next].focus();
      modeButtons[next].click();
    });
  });

  searchInput.addEventListener("input", function () { renderSearch(searchInput.value); });

  document.addEventListener("click", function (event) {
    var allTreatments = event.target.closest("[data-pricing-show-categories]");
    if (allTreatments && document.querySelector("[data-drsknn-pricing-v2]")) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var close = document.querySelector("[data-drsknn-pricing-v2-source] [data-pricing-close-modal]");
      if (close) close.click();
      setQuery({ pricing: "" });
      setMode("search", { focus: true });
      root.querySelector(".drsknn-pricing-v2__finder").scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    if (event.target.closest("[data-drsknn-pricing-v2-source] [data-pricing-close-modal]")) {
      window.setTimeout(function () { setQuery({ pricing: "" }); }, 0);
    }
  }, true);

  installSelectedTreatmentEnhancement();
  renderAreas();
  renderConcerns();
  renderResults();
  renderSearch("");

  try {
    var params = new URLSearchParams(window.location.search || "");
    var initialArea = params.get("area") || "";
    var initialConcern = params.get("concern") || "";
    var initialPricing = params.get("pricing") || params.get("pricing_key") || "";
    if (concerns[initialArea]) {
      state.area = initialArea;
      state.concern = (concerns[initialArea] || []).some(function (item) { return item.key === initialConcern; }) ? initialConcern : "";
      renderAreas();
      renderConcerns();
      renderResults();
    }
    setMode(params.get("price_route") === "search" ? "search" : "help", { focus: false });
    if (treatmentByKey[initialPricing]) window.setTimeout(function () { openPrice(initialPricing, null); }, 80);
  } catch (_) {
    setMode("help", { focus: false });
  }

  window.DrSknnPricingV2 = {
    openPrice: openPrice,
    standardize: ensureStandardCatalogue,
    standardizeAll: function () {
      treatments.forEach(function (item) { ensureStandardCatalogue(item.key); });
    },
    treatmentCount: treatments.length,
    version: "2.2.0"
  };
})();
